import { ReactNode, createContext, useMemo } from 'react';

import { MongoAbility } from '@casl/ability';

import { RoleEnum } from '@/app/enums/RoleEnum';

import { defineAbility } from '.';
import { Actions, Subjects } from './types';

const AbilityContext = createContext<MongoAbility<[Actions, Subjects]>>(
  {} as MongoAbility<[Actions, Subjects]>,
);

const AbilityProvider = ({ role, children }: { role?: RoleEnum | number; children: ReactNode }) => {
  const ability = useMemo(() => defineAbility(role), [role]);

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
};

export { AbilityContext, AbilityProvider };
